import React, { useEffect, useState,useRef } from 'react';
import { Link, useNavigate,useLocation,useSearchParams } from "react-router-dom";
import { driver } from "driver.js";
import "driver.js/dist/driver.css";
import gradehelp1 from '../assets/img/gradehelp1.png'
import gradehelp2 from '../assets/img/gradehelp2.jpg'
import gradehelp3 from '../assets/img/gradehelp3.PNG'

const CGPACalculator = () => {
    const [numSem, setNumSem] = useState();
    const [semData, setSemData] = useState([]);
    const [cgpa1,setCgpa1]=useState(0);
    const [totalGP,setTGP]=useState(0);
    const [totalC,setTC]=useState(0);
  
    const handleNumSemChange = (e) => {
      const numSem = parseInt(e.target.value);
      setNumSem(numSem);
      setSemData(Array.from({ length: numSem }, (_, i) => ({
        semNo: i + 1,
        gp: '',
        credit: '',
        cgpa: 0,
        sgpa:0
      })));
    };
  
    const handleGradeChange = (semNo, e) => {
        const updatedSemData = semData.map(sem => sem.semNo === semNo ? { ...sem, gp: parseFloat(e.target.value) } : sem);
        setSemData(updatedSemData);
    };
  
    const handleCreditChange = (semNo, e) => {
        const updatedSemData = semData.map(sem => sem.semNo === semNo ? { ...sem, credit: parseFloat(e.target.value) } : sem);
        setSemData(updatedSemData);
    };
  
    const calculateCGPA = () => {
        let totalGradePoints = 0;
        let totalCredits = 0;
        const updatedSemDataWithCGPA = semData.map(sem => {
        if (!sem.gp || !sem.credit) {
          alert(`Please fill all fields for Semester ${sem.semNo}`);
          return sem;
        }
        
       const cgpa1 =semData.reduce((total, sem) => total + sem.gp, 0) / semData.reduce((total, sem) => total + sem.credit, 0);
       setCgpa1(cgpa1)
        totalGradePoints += sem.gp;
    totalCredits += sem.credit;
    setTGP(totalGradePoints);
    setTC(totalCredits);

   /* const cgpa = Math.round(totalGradePoints) / totalCredits;
    const sgpa =Math.round(sem.gp) / sem.credit;  */

    const cgpa = totalGradePoints / totalCredits;
    const sgpa =sem.gp / sem.credit; 

        return { ...sem, cgpa,sgpa };
      });
      setSemData(updatedSemDataWithCGPA);
    };

  return (
    <div className='container mt-2 mb-5'>
      <h3>CGPA calculator <span style={{color:"blue",cursor:"pointer",fontSize:"16px"}} id='_help_'  >How to Use?</span></h3>
      <hr />
      <div id='inputgroup' className="input-group mb-3">
        <span className="input-group-text bg-uni"><label htmlFor='nsp' style={{"cursor":"pointer"}}>Total no. of semesters</label></span>
        <input
        id='nsp'
          className="form-control"
          min="0"
          max="8"
          placeholder="No. of semesters you passed"
          type="number"
          value={numSem}
          onChange={handleNumSemChange}
        />
      </div>
      {numSem > 0 && (
        <>
          <table className="table">
            <thead>
              <tr>
                <th id='sem_no'>Semester</th>
                <th id='gradepoints'>Grade Points <Link id='needhelp' data-bs-toggle="modal" data-bs-target="#helpModal" >Need help?</Link></th>
                <th id='totalcredit' >Total Credit</th>
                {/* <th id='sgpa' >SGPA</th>
                <th id='cgpa'>CGPA</th> */}
               
              </tr>
            </thead>
            <tbody>
              {semData.map(sem => (
                <tr key={sem.semNo}>
                  <td>Semester {sem.semNo}</td>
                  <td>
                    <input
                      className="form-control form-control-sm"
                      step={0.1}
                      type="number"
                      value={sem.gp}
                      onChange={(e) => handleGradeChange(sem.semNo, e)}
                    />
                  </td>
                  <td>
                    <input
                      className="form-control form-control-sm"
                      step={0.1}
                      type="number"
                      value={sem.credit}
                      onChange={(e) => handleCreditChange(sem.semNo, e)}
                    />
                  </td>
                  {/* <td>
                    <input
                      className="form-control form-control-sm"
                      type="number"
                      value={sem.sgpa.toFixed(2)}
                      readOnly
                    />
                  </td>

                  <td>
                    <input
                      className="form-control form-control-sm"
                      type="number"
                      value={sem.cgpa.toFixed(2)}
                      readOnly
                    />
                  </td> */}
                  
                </tr>
              ))}
            </tbody>
          </table>
          <button id='btn-cal-cgpa' className='btn btn-primary w-100' onClick={calculateCGPA} data-bs-toggle="modal" data-bs-target="#exampleModal">Calculate CGPA</button>
        </>
      )}


      <>


      <div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h1 class="modal-title fs-5" id="exampleModalLabel">Your CGPA: {cgpa1.toFixed(2)}</h1>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
    
       <table className="table table-bordered" >
            <thead>
              <tr>
                <th>Semester</th>
                <th>Total Credit</th>
                <th>Grade Points</th>
                <th>SGPA</th>
                {/* <th>CGPA</th> */}
                <th>%</th>
                               
              </tr>
            </thead>
            <tbody>
              {semData.map(sem => (
                <tr key={sem.semNo}>
                  <td>Semester {sem.semNo}</td>
                  <td>{sem.credit}</td>
                  <td>{sem.gp}</td>
                  <td>{sem.sgpa.toFixed(2)}</td>
                  {/* <td>{sem.cgpa.toFixed(2)}</td> */}
                  <td>{sem.sgpa>0?((sem.sgpa-0.5)*10).toFixed(2):0}</td>
                </tr>

              ))}
              </tbody>
              </table>
 
<b>Cummulative Performance:</b>

<table className='table table-bordered'>
<thead>
<tr>
<th>Credits</th>
<th>Grade Points</th>
<th>CGPA</th>
</tr>
</thead>
<tbody>
<tr>
  <td>{totalC}</td>
  <td>{totalGP}</td>
  <td>{cgpa1.toFixed(2)}</td>
</tr>
</tbody>
</table>

      </div>
      <div class="modal-footer">

        <button type="button" data-bs-dismiss="modal" class="btn btn-primary">Ok</button>
      </div>
    </div>
  </div>
</div>


      <div class="modal  modal-dialog-scrollable fade" id="helpModal" tabindex="-1" aria-labelledby="helpModalLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h1 class="modal-title fs-5" id="helpModalLabel">Need help finding or calculating grade points?</h1>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
         
<b>If you have a marksheet with numerical marks: </b>
To find your grade points, refer to your marksheet. Look for the sections that indicate the grade points and total credits. The red marks on the images below show you where to find this information. Once you locate it, you can use it to calculate your CGPA.
<br/><br/>

<b>If you have grades (EX, AA, AB, BB, etc.) without numerical marks: </b>
You can calculate your grade points by using the Grade to SGPA converter. This tool will calculate your SGPA as well as your grade points and total credits.<br/>

<div className="text-center p-2">
<Link to='/grade-to-sgpa' className='btn btn-sm btn-primary' data-bs-dismiss="modal" onClick={()=>{window.location.href = "/grade-to-sgpa"}}>calculate Grade Points</Link>
</div>             
                <img width={"100%"} src={gradehelp1} alt="" /><br/><br/>
                <img width={"100%"} src={gradehelp2} alt="" /><br/><br/>
                <img width={"100%"} src={gradehelp3} alt="" />
      </div>
      <div class="modal-footer">

        <button  type="button" data-bs-dismiss="modal" class="btn btn-primary">Ok</button>
      </div>
    </div>
  </div>
</div>
      </>
      <TourGuide/>
    </div>

  );
};

export default CGPACalculator;



function TourGuide(props){

  const location = useLocation();
  const driverObjRef = useRef(null);


  useEffect(() => {

    const _help_=document.getElementById("_help_");
  

const driverObj = driver({
  // showProgress: true,
  allowClose: true,
// overlayColor: '#47d3ceab',
    popoverClass: 'driverjs-theme',
    showButtons: ['next', 'previous','close'],

  steps: [
    { element: '#inputgroup', popover: { title: 'Quick Start Guide', description: 'Learn how to use CGPA Calculator...', side: "right", align: 'center' } },
    { element: '#nsp', popover: { title: 'No of semesters', description: 'Enter number of semesters you have passed till now.</br> <b>Note</b>: <i>to get help for next step first enter no. of semesters in input box.</i>', side: "right", align: 'center' } },
    { element: '#sem_no', popover: { title: 'Semester', description: 'This column indicates semester Number.', side: "right", align: 'center' } },
    { element: '#gradepoints', popover: { title: 'Grade Points', description: 'In this column you need to Enter Grade Points for individual semester in input box of each row.', side: "right", align: 'center' } },
    { element: '#needhelp', popover: { title: 'Need help finding or calculating grade points?', description: 'click on <b>Need Help?</b> link this will guide you to find or calculate grade points. </br><b>Note:</b><i>Read carefully all the steps to avoid mistakes.</i>', side: "right", align: 'center' } },
    { element: '#totalcredit', popover: { title: 'Total Credit', description: 'In this column you need to Enter Total credit for individual semester in input box of each row.</br><b>Note:</b><i>If you don\'t know where to find credit then follow previous step guide by clicking on <b>Previous</b> Button below.</i>', side: "right", align: 'center' } },
    { element: '#btn-cal-cgpa', popover: { title: 'Click on calculate CGPA button', description: 'after putting grade points & Total Credit in above table, then click on <b>Calculate CGPA</b> Button.</br><i>Congratulation! You have successfully calculated your SGPA & CGPA. Happy Learning! Thank You!</i>', side: "right", align: 'center' } },
    { element: '#sgpa', popover: { title: 'SGPA', description: 'This column shows calculated SGPA.</br> <b>Note:</b> <i>You don\'t need to fill SGPA fields. this will be calculated automatically After clicking on Calculate CGPA button.</i>', side: "right", align: 'center' } },
    { element: '#cgpa', popover: { title: 'CGPA', description: 'This column shows calculated CGPA.</br> <b>Note:</b> <i>You don\'t need to fill SGPA fields. this will be calculated automatically After clicking on Calculate CGPA button.', side: "right", align: 'center' } },
  ],

  onDestroyStarted: () => {
    if (!driverObj.hasNextStep()) {
      
      if(localStorage.isnewusercgpacal){
        localStorage.setItem('isnewusercgpacal','false');
      }
      
      driverObj.destroy();
    }
  },

  onCloseClick:() => {

if(Number(localStorage.countsclickcgpacal)>=2){
    if(localStorage.isnewusercgpacal){
      localStorage.setItem('isnewusercgpacal','false');
    }
  }
    driverObj.destroy();

    localStorage.setItem('countsclickcgpacal',Number(localStorage.countsclickcgpacal)+1);
    console.log(Number(localStorage.countsclickcgpacal));
 
  },

});
driverObjRef.current = driverObj;

if(!localStorage.isnewusercgpacal){
  localStorage.setItem('isnewusercgpacal','true');
}

if(!localStorage.countsclickcgpacal){
  localStorage.setItem('countsclickcgpacal','0');
}

if(localStorage.isnewusercgpacal=="true"){
  driverObj.drive();
}

_help_.addEventListener("click",()=>{
  driverObj.drive()
});


return () => {
  if (driverObjRef.current) {
    driverObjRef.current.destroy(); 
  }
};
}, [location.pathname]);

  return(
      <>
      
      </>
  )
}